<template>
    <transition
        :name="getTransition"
        class="Modal"
        @:after-leave="animationFinished"
    >
        <div
            v-if="showModal"
            :class="`FullScreenModal--${type}`"
            class="FullScreenModal"
        >
            <div
                :style="contentStyle"
                class="FullScreenModal-content"
            >
                <div
                    :style="contentSlotStyle"
                    class="FullScreenModal-contentSlot"
                >
                    <slot />
                </div>
            </div>
            <div
                v-show="type==='default'"
                class="FullScreenModal-footer"
            >
                <button
                    class="FullScreenModal-footerCloseButton"
                    @click="hideModal"
                >
                    <span class="f2m-close" />
                </button>
            </div>
            <div
                v-show="type==='custom'"
                class="FullScreenModal-footerCustom"
            >
                <slot name="footer" />
            </div>
        </div>
    </transition>
</template>

<script>
import Transition   from "@/components/Transition.vue";

export default {
    components: {
        Transition
    },
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            default: 'default',
            validator: (val) => ['default', 'success', 'custom'].includes(val)
        },
        contentStyle: {
            type: Object,
            default: () => ({})
        },
        contentSlotStyle: {
            type: Object,
            default: () => ({})
        },
    },
    computed: {
        getTransition () {
            return 'fade';
        }
    },
    watch: {
        showModal (val) {
            if (val) {
                document.body.classList.add('body--withModalOpened')
            } else {
                document.body.classList.remove('body--withModalOpened')
            }
        }
    },
    methods: {
        hideModal () {
            document.body.classList.remove('body--withModalOpened')
            this.$emit('hideModal')
        },
        animationFinished () {
            this.$emit('animationFinished')
        }
    }
}
</script>

<style lang="scss" scoped>

.FullScreenModal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background: $color-f2m-gradient;

    &-content {
        overflow-y: auto;
        height: calc(100vh - 68px);
    }

    &--success {
        background: $color-green;
    }

    &-footer{
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
        width: 100%;
        bottom: 0;
        background: linear-gradient(180deg, rgba(45, 107, 210, 0) 0%, #3268D2 100%);
    }

    &-footerCloseButton {
        width: 56px;
        height: 56px;
        border: none;
        border-radius: 50%;
        background-color: $color-white;
        color: $color-f2m-pink;
        font-size: 17px;
        cursor: pointer;

        &:hover {
            color: $color-f2m-pink--hovered;
        }
    }

    &-footerCustom {
        position: absolute;
        width: 100%;
        bottom: 0;
    }
}
</style>

